// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { USER_MODULE, USER_URL } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { UserRejectedIndex } = lazily(() => import('pages/back-office/user/user-rejected'))

const userRejectedRoutes: IRoute[] = [
  {
    path: USER_URL.REJECTED,
    component: UserRejectedIndex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: USER_MODULE,
      requireAuth: true,
      attrs: {
        label: 'user.rejected',
        accessCodes: [444],
      },
    },
  },
]

export { userRejectedRoutes }
